import * as Actions from '../actions';

const initialState = {
    eventStudentList:  [],
    courseEventList:   [],
    courseStudentList: [],
    studentEventList:  [],
    courseList:        [],
    course_name:       '',
    event_name:        '',
    student_name:      '',
    event_info: {
        EventName:  '',
        EventDate:  '',
        StartTime:  '',
        EndTime:    '',
        CourseName: '',
        LessonName: '',
        EventType:  '',
    },
    course_gradebook: {
        course_info:  {
            course_total_points: 0,
            is_unscheduled:      0,
        },
        event_list:   [],
        student_list: [],
    },
    student_gradebook: {
        course_info: {
            course_id:         0,
            Unscheduled:       0,
            StartDate:         '',
            EndDate:           '',
            CourseName:        '',
            CourseDescription: '',
            instructor_list:   [],
        },
        student_info:       {
            FirstName: '',
            LastName:  '',
            Email:     '',
        },
        student_grade_info: {
            course_total: 0,
            course_max:   0,
            is_passing:   false,
        },
        event_list:         [],
    }
}

const gradebookReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.GET_EVENT_STUDENT_LIST):
        {
            const { event_name, eventStudentList } = action.payload;
            
            return {
                ...state,
                eventStudentList: eventStudentList,
                event_name: event_name
            }
        }
        case (Actions.GET_COURSE_EVENT_LIST):
        {
            return {
                ...state,
                courseEventList: action.payload
            }
        }
        case (Actions.GET_COURSE_STUDENT_LIST):
        {
            return {
                ...state,
                courseStudentList: action.payload
            }
        }
        case (Actions.GET_COURSE_NAME):
        {
            return {
                ...state,
                course_name: action.payload
            }
        }
        case (Actions.GET_STUDENT_NAME):
        {
            return {
                ...state,
                student_name: action.payload
            }
        }
        case (Actions.GET_COURSE_LIST):
        {
            return {
                ...state,
                courseList: action.payload
            }
        }
        case (Actions.GET_STUDENT_EVENT_LIST):
        {
            return {
                ...state,
                studentEventList: action.payload
            }
        }
        case (Actions.UPDATE_GRADEBOOK_SCORE):
        {
            const { gradebook_detail_id, new_score } = action.payload;

            return {
                ...state,
                studentEventList: state.studentEventList.map((student_event) => {
                    if(student_event.gradebook_detail_id === gradebook_detail_id) {
                        return {
                            ...student_event,
                            GradebookScore: new_score
                        };
                    } else {
                        return student_event;
                    }
                }),
                eventStudentList: state.eventStudentList.map((student_event) => {
                    if(student_event.gradebook_detail_id === gradebook_detail_id) {
                        return {
                            ...student_event,
                            GradebookScore: new_score
                        };
                    } else {
                        return student_event;
                    }
                }),
                student_gradebook: {
                    ...state.student_gradebook,
                    event_list: state.student_gradebook.event_list.map((student_event) => {
                        if (student_event.gradebook_detail_id === gradebook_detail_id) {
                            return {
                                ...student_event,
                                GradebookScore: new_score
                            };
                        } else {
                            return student_event;
                        }
                    })
                }
            }
        }
        case (Actions.GET_EVENT_INFO):
        {
            return {
                ...state,
                event_info: action.payload
            }
        }
        case (Actions.GET_COURSE_GRADEBOOK):
        {
            return {
                ...state,
                course_gradebook: action.payload
            }
        }

        case (Actions.GET_STUDENT_GRADEBOOK):
        {
            const { course_info, student_info, event_list, student_grade_info } = action.payload;
            
            return {
                ...state,
                student_gradebook: {
                    ...state.student_gradebook,
                    course_info:        course_info,
                    student_info:       student_info,
                    event_list:         event_list,
                    student_grade_info: student_grade_info,
                }
            }
        }

        default:
        {
            return state;
        }
    }
}

export default gradebookReducer;


// WEBPACK FOOTER //
// src/main/content/gradebook/store/reducers/gradebook.reducer.js